import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue'

export const pravicePridelavaService = {
    load,save
    
};

function load(sezona) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelovalec/pravice?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(pravicePridelava => {
            // login successful if there's a jwt token in the response
            
            return pravicePridelava;
        });
}
function save(pravicePridelava) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(pravicePridelava)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelovalec/pravice`, requestOptions).then(handleResponse);
}

